/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import servers from '../../utils/servers';
import { Attachment, AttachmentDeleteParams } from '../../models/attachments';
import ImageCarousel from './carousel';
import MapAttachmentThumbnails from './mapThumbnails';
import FileUploader from './fileUploader';
import styles from './fileViewer.module.less';

declare global {
  interface Window {
    images: HTMLImageElement[];
  }
}

interface FileViewerProps {
  addAttachment?: (file: FileList) => void;
  handleDeleteClick?: (params: AttachmentDeleteParams) => void;
  allowDelete?: boolean;
  disableAddition?: boolean;
  attachments?: Attachment[];
  uploaderVisible?: boolean;
  fileInputId?: string;
}

const FileViewer: React.FC<FileViewerProps> = ({
  attachments,
  addAttachment,
  handleDeleteClick,
  allowDelete = true,
  disableAddition = false,
  uploaderVisible = true,
  fileInputId = 'file-upload',
}) => {
  const [showFile, toggleShowFile] = useState({ visible: false, index: 0 });

  const fileRef = useRef<HTMLInputElement>();

  const fileUpload = (): void => {
    addAttachment(fileRef.current.files);
    fileRef.current.value = '';
  };

  const handleDelete = ({ fileName, fileId }): void => {
    handleDeleteClick({ fileName, fileId });
    if (attachments.filter((item) => !item?._destroy).length > 1) {
      toggleShowFile({ visible: true, index: showFile.index > 0 ? showFile.index - 1 : 0 });
    } else {
      toggleShowFile({ visible: false, index: 0 });
    }
  };

  useEffect(() => {
    // preload images
    // using global context to prevent preloads from being
    // garbage collected on component unmount
    window.images = [];
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    Array.isArray(attachments) &&
      attachments.forEach((attachment) => {
        if (attachment?.content_type) {
          const img = new Image();
          img.src = `${servers.api}/${attachment.url}`;
          window.images.push(img);
        } else {
          const img = new Image();
          img.src = attachment.attachment;
          window.images.push(img);
        }
      });
  }, [attachments?.length]);

  return (
    <>
      {showFile.visible && (
        <ImageCarousel
          attachments={attachments.filter((item) => !item._destroy)}
          toggleShowFile={toggleShowFile}
          chosenIndex={showFile.index}
          handleDeleteClick={handleDelete}
          allowDelete={allowDelete}
        />
      )}
      <div className={styles.attachmentWrapper}>
        <MapAttachmentThumbnails attachments={attachments} toggleShowFile={toggleShowFile} />
        {uploaderVisible ? (
          <FileUploader
            fileRef={fileRef}
            fileUpload={fileUpload}
            disableAddition={disableAddition}
            inputId={fileInputId}
          />
        ) : null}
      </div>
    </>
  );
};

export default FileViewer;
